<template>
    <div>
      <div v-if="question.questionType=='Checkbox'" class="question_instructions">({{ $t("front_end.plusieurs_choix").toLowerCase() }})</div>
        <div class="answer_container" :class="$mq">
          <div
            v-for="(choice, index) in answerList"
            v-if="question.answers.length > 0"
            class="answerCard"
            :class="[{ checked: choice.checked }, $mq]"
            @click="questionClicked(choice.answer, choice.checked)"
            >
            <div class="vcentered">
                <p :style="fitCard($options.filters.translategrader(choice.answer, $i18n.locale))" v-html="applySmartquotes($options.filters.translategrader(choice.answer, $i18n.locale))"></p>
              </div>
              <img src="@/assets/img/selected_checked.svg" width="16" class="selected_img" v-if="choice.checked">
              <img src="@/assets/img/multi_selected.svg" width="16" class="selected_img" v-if="!choice.checked && question.questionType=='Checkbox'">
          </div>
        </div>

      <div class="checkboxValidate text-center" v-if="question.questionType=='Checkbox'">
        <button
        type="button"
        class="btn btn-survey"
        :style="btnSurvey"
        :disabled="choiceCheckedCount==0"
        @click="validateChoices"
        >
          {{ $t("front_end.valider") }}
        </button>
      </div>

  </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex';
import smartquotes from 'smartquotes';

export default {
  name: 'SurveyChoices',

  data () {
    return {
      result: []
    }
  },

  props: ['pageIdx', 'question', 'questionIdx', 'color'],

  updated() {
    // Setting color variable in css
    // See https://codepen.io/shshaw/pen/qrQGQQ
    this.$el.style.setProperty('--colorCategory', this.color) ;

  },


  methods: {

    ...mapActions(
      {
        saveAnswer: 'survey/saveAnswer',
      }),

    applySmartquotes(a) {
        a = smartquotes(a);
        a = a.replace(/\u201c/g, "\u00AB\&nbsp;");
        a = a.replace(/\u201d/g, "\&nbsp;\u00BB");
        a = a.replace(/(\w) \?/g, '$1&nbsp;?'); // add nb spaces before '?'
        return a;
      },

    fitCard(answer) {

      var charCount = answer.length;
      if (this.$mq === "sm") {
        var fontSize = "12px";
        if (charCount > 100) {
          fontSize = "10.5px"
        }
      }
      else {
        var fontSize = "14px";
        // if (charCount > 50) {
        //   fontSize = "15px"
        // };
        // if (charCount > 80) {
        //   fontSize = "14px"
        // };
        if (charCount > 100) {
          fontSize = "12.5px"
        }
      }



      return {
        fontSize: fontSize
      }
    },

    shuffle(array) {
      console.log("In shuffle")
      var currentIndex = array.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },


    async questionClicked(answer, checked_before) {

      console.log("clicked on question: ", this.questionIdx);
      // We pass the 'answer' and 'checked_before' state to the function
      // Then we create a copy of the current profile checkboxes
      // We loop through the values, and only change the one with the same name
      var updatedQuestion = this.question;

      var tmp_answers = this.question.answers.slice(); // to do a copy of the array

      if (this.question.questionType == "Checkbox") {
        // Loop through all possible values and update the checked one
        for(var i = 0; i < tmp_answers.length; i++){
          if (tmp_answers[i]["answer"] == answer) {
            tmp_answers[i]["checked"] = !checked_before;
          }
        }
      } else {
        // Loop through all possible values and update the checked one
        for(var i = 0; i < tmp_answers.length; i++){
          if (tmp_answers[i]["answer"] == answer) {
            tmp_answers[i]["checked"] = true;
          } else {
            tmp_answers[i]["checked"] = false;
          }
        }
      }

      updatedQuestion["answers"] = tmp_answers;

      var payload = {
        'page_number': this.pageIdx,
        'question_idx': this.questionIdx,
        'userAnswer': this.result,
        'question': updatedQuestion
      };

      await this.saveAnswer(payload);

      if (this.question.questionType != "Checkbox") {
        this.validateChoices();
      }

    },

    validateChoices() {
      // Emit an event
      this.$emit('answer-validated');
    }

  },

  computed: {

      answerList: function() {
        if (this.settings.show_question_ordered === true) {
          return this.question.answers;
        } else {
          console.log("Should shuffle")
          return this.shuffle(this.question.answers);
        }
    },

    ...mapGetters('settings', {
      settings: 'settings',
    }),

    // Styles
    bg_color: function(){
        var bgColor= this.color;
        return {
          "background-color": bgColor,
        }
    },

    border_color: function(){
        var bgColor= this.color;
        return {
          "border-color": bgColor
        }
    },
    font_color: function(){
        var bgColor= this.color;
        return {
          "color": bgColor
        }
    },

    btnSurvey: function(){
        var bgColor= this.color;
        return {
          "background-color": bgColor,
          "border-color": bgColor
        }
    },

    choiceCheckedCount: function() {
      // How many choices are checked for this question ?
      var choiceCheckedCount = 0;
      var tmp_answers = this.question.answers;

      // Loop through all possible values and update the checked one
      for(var i = 0; i < tmp_answers.length; i++){
        if (tmp_answers[i]["checked"]) {
          choiceCheckedCount++;
        }
      }
      return choiceCheckedCount;
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.question_instructions {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: 'Nunito', sans-serif;
  color: #051e41;
}

.answer_container {
  display: flex;
  margin-top: 19px;
  align-items: center;
  justify-content: center;
}

.answerCard {
  position: relative;
  height: 173px;
  border: 3px solid #C0C6CD;
  flex: 1 0 21%;
  border-radius: 9px;
  padding: 27px;
  background: #fff;
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.07);
  cursor: pointer;
}

.answerCard p {
  color: #051e41;
}
.answerCard.checked p {
  color: #051e41;
  font-weight: 900;
}

.checkboxValidate {
  padding-top: 3rem;
}

.vcentered {
  /*height: 50%;
  overflow: none;
  margin: auto 20px;
  position: absolute;
  top: 0; left: 0; bottom: 0; right: 0;*/

  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}

.vcentered p {
  display: table-cell;
  vertical-align: middle;
}

@media screen and (max-width: 991px) {
  .answer_container {
    flex-wrap: wrap;
  }

  .answerCard {
    flex: 1 0 41%;
    height: auto;
    max-width: 45%;
    margin-bottom: 10px;
  }

}


.answerCard:hover, .answerCard.checked:hover {
  border-color: var(--colorCategory);
  box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.25);
}

.answerCard:hover {
  color: var(--colorCategory);
}

.selected_img {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.answerCard.checked {
  border-color: var(--colorCategory);
  background-color: var(--colorCategory);
  box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.07);
  color: #ffffff;
}

.answerCard:not(:last-child) {
  margin-right: 16px;
}


input[type="checkbox"] {
  display: none;
}
input[type="checkbox"]:not(:disabled) ~ label {
  cursor: pointer;
}
input[type="checkbox"]:disabled ~ label {
  color: #bcc2bf;
  border-color: #bcc2bf;
  box-shadow: none;
  cursor: not-allowed;
}

label {
  height: 100%;
  display: block;
  background: white;
  border: 2px solid #eee;
  border-radius: 5px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
  box-shadow: 0px 3px 10px -2px rgba(161, 170, 166, 0.5);
  position: relative;
}

input[type="checkbox"]:checked + label {
  background: rgb(221,212, 69);
  color: white;
}

input[type="checkbox"]:checked + label::after {
  color: #3d3f43;
  font-family: FontAwesome;
  border: 2px solid rgb(250,240,230);
  content: "\f00c";
  font-size: 15px;
  position: absolute;
  top: -15px;
  left: 0%;
  transform: translateX(0%);
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  background: white;
  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.25);
}
p {
  font-size: 20px;
}

.btn-survey {
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
  color: #fff;
  border-radius: 10px;
  padding: 10px 25px;
}

.btn:disabled {
  background-color: #ccc!important;
  border-color: #ccc!important;
}

@media only screen and (max-width: 991px) {
  section {
    flex-direction: column;
  }

  .btn-survey {
    font-size: 14px;
    border-radius: 10px;
    padding: 5px 10px;
  }
}

@media only screen and (max-width: 991px) {

  .answer_container {
    margin-top: 12px;
  }

  .answerCard {
    height: 150px;
    max-height: calc(100vh - 550px);
    padding: 18px;
    display: table;
  }

  p {
    line-height: 1.1em;
    display: table-cell;
    vertical-align: middle;
  }

  .answerCard:not(:last-child) {
    margin-right: 5px;
  }
  .answerCard {
    margin: 5px;
  }

  .answerCard:nth-child(-n + 2) {
    margin-bottom: 12px;
  }

  .checkboxValidate {
    padding-top: 6px;
  }

}


.answerCard.sm {
    height: 150px;
    max-height: calc(100vh - 440px);
    padding: 10px;
    display: table;
  }

.answerCard.sm p {
  font-size: 10px;
}

.answer_container.sm {
  margin-top: 4px;
}
.answer_container.sm .vcentered{
  padding-left: 8px;
  padding-right: 8px;
}



</style>



// WEBPACK FOOTER //
// src/components/survey_elements/SurveyChoices.vue